import { render, staticRenderFns } from "./TabFirmed.vue?vue&type=template&id=609ca382&"
import script from "./TabFirmed.vue?vue&type=script&lang=ts&"
export * from "./TabFirmed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports